import { motion } from "framer-motion";

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 md:py-32 bg-gradient-hero">
      <div className="container px-6 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3 font-body">
            Let’s Build the Future Together
          </p>
          <h2 className="text-3xl md:text-5xl font-bold font-display mb-6">
            Start Your <span className="text-gradient-red">AI Journey</span>
          </h2>
          <p className="text-muted-foreground font-body leading-relaxed">
            Have an idea, a challenge, or a transformation goal?
            We design AI-powered systems that move your business forward.
          </p>
        </motion.div>

        <motion.form
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid gap-6"
        >
          <input
            type="text"
            placeholder="Full Name"
            className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body"
          />

          <input
            type="text"
            placeholder="Company"
            className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body"
          />

          <input
            type="email"
            placeholder="Email"
            className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body"
          />

          <textarea
            rows={4}
            placeholder="Project Description"
            className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body resize-none"
          />

          <div className="grid md:grid-cols-2 gap-6">
            <input
              type="text"
              placeholder="Budget Range"
              className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body"
            />
            <input
              type="text"
              placeholder="Timeline"
              className="w-full p-4 rounded-lg bg-card border border-glass focus:border-primary outline-none text-sm font-body"
            />
          </div>

          <button
            type="submit"
            className="mt-4 bg-gradient-red text-primary-foreground px-10 py-3.5 rounded-lg font-display font-medium text-sm tracking-wide hover:opacity-90 transition-opacity shadow-glow"
          >
            Start Your AI Journey
          </button>
        </motion.form>
      </div>
    </section>
  );
};

export default ContactSection;